import { useQuery } from '@tanstack/react-query';
import { orderKeys, type OrderListQuery } from '@/services/queryKeys';
import { orderService } from '@/services/order.service';

export function useOrderList(query: OrderListQuery) {
  return useQuery({
    queryKey: orderKeys.list(query),
    queryFn: () => orderService.list(query),
    placeholderData: (prev) => prev,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: 'always',
    retry: 0,
  });
}
